<mat-card flex="100">
  <mat-card-title>
    {{ (airCarrier$ | async)?.abbreviation }} User Activity
    <button mat-raised-button (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div
      fxLayout="row wrap"
      fxLayoutGap="10px"
      fxLayoutAlign="start start"
      [formGroup]="userActivityReportParameters"
    >
      <div fxLayout="row" fxLayoutGap="15px">
        <fl-autocomplete
          fxFlex="200px"
          [placeholder]="'User'"
          [inputControl]="userActivityReportParameters.controls.lastUpdatedById"
          [options]="employeeOptions$ | async"
          (search)="onEmployeeSearch($event)"
          [useMatInput]="true"
          [fullWidth]="true"
          [initialSelectedItem]="selectedEmployee"
        >
        </fl-autocomplete>
        <button
          mat-button
          *ngIf="userActivityReportParameters.controls.lastUpdatedById.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="userActivityReportParameters.controls.lastUpdatedById.reset()"
          class="autocomplete-clear-button"
        >
          <mat-icon>close</mat-icon>
        </button>
        <fl-autocomplete
          fxFlex="200px"
          [placeholder]="'Pilot'"
          [inputControl]="userActivityReportParameters.controls.pilotId"
          [options]="pilotOptions$ | async"
          (search)="onPilotSearch($event)"
          [useMatInput]="true"
          [fullWidth]="true"
          [initialSelectedItem]="selectedPilot"
        >
        </fl-autocomplete>
        <button
          mat-button
          *ngIf="userActivityReportParameters.controls.pilotId.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="userActivityReportParameters.controls.pilotId.reset()"
          class="autocomplete-clear-button"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-form-field fxFlex="250px">
          <mat-label>Entity Type</mat-label>
          <mat-select formControlName="entityType">
            <mat-option [value]=""> </mat-option>
            <mat-option *ngFor="let option of entityTypeOptions" [value]="option">
              {{ humanizeEntityName(option) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div fxFlex="160px" fxLayoutAlign="start center">
          <mat-label>Last updated date range:</mat-label>
        </div>
        <mat-form-field fxFlex="100px">
          <input
            matInput
            [formControl]="startDateCtrl"
            [matDatepicker]="startPicker"
            [max]="endDateCtrl.value"
            placeholder="Start date"
          />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field fxFlex="100px">
          <input
            matInput
            [formControl]="endDateCtrl"
            [matDatepicker]="endPicker"
            [min]="startDateCtrl.value"
            [max]="maxDate"
            placeholder="End date"
          />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
        <button
          class="reset-filters-button"
          mat-raised-button
          color="secondary"
          (click)="resetFilters()"
        >
          Reset Filters
        </button>
      </div>
    </div>
    <div>
      <ng-template
        [flLoading]="loadingKey"
        [flLoadingUntil]="userActivityReports$ | async"
        flLoadingStrategy="overlay"
        flLoadingColor="primary"
      >
        <table mat-table [dataSource]="userActivityReports$" fxFlex="100">
          <ng-container matColumnDef="pilotName">
            <th mat-header-cell *matHeaderCellDef>Pilot Name</th>
            <td mat-cell *matCellDef="let userActivityReport">
              {{ userActivityReport.pilotFirstName }} {{ userActivityReport.pilotLastName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="entityType">
            <th mat-header-cell *matHeaderCellDef>Entity Type</th>
            <td mat-cell *matCellDef="let userActivityReport">
              {{ humanizeEntityName(userActivityReport.entityTypeName) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="createdDate">
            <th mat-header-cell *matHeaderCellDef>Date Created</th>
            <td mat-cell *matCellDef="let userActivityReport">
              {{ (userActivityReport.createdAt | date : 'MM/dd/yyyy @ HH:mm') || '--' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="lastUpdate">
            <th mat-header-cell *matHeaderCellDef>Last Updated</th>
            <td mat-cell *matCellDef="let userActivityReport">
              {{ (userActivityReport.updatedAt | date : 'MM/dd/yyyy @ HH:mm') || '--' }}
              <span *ngIf="userActivityReport.updatedByName"
                >by {{ userActivityReport.updatedByName }}</span
              >
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </ng-template>
    </div>
    <div>
      <mat-paginator
        [pageSize]="pageSize$ | async"
        [pageIndex]="pageIndex$ | async"
        [pageSizeOptions]="pageSizeOptions"
        [length]="total$ | async"
        (page)="onPage($event)"
      >
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
